import type { ConnectionStatus } from '@capacitor/network'

export const makeConnectionStatus = (connected: boolean): ConnectionStatus => ({
  connected,
  connectionType: connected ? 'unknown' : 'none',
})
